import { TextProps } from "@chakra-ui/react";
import React from "react";
import { FormInputValue } from "shared/types/FormInputValue";

/***
 * @deprecated use `SelectOption`
 */
export interface SelectElement {
  value: FormInputValue;
  rich_value: string;
}

type PlainNode = string | number | null | PlainNode[];

export interface SelectOptionProps {
  value: FormInputValue;
  children?: PlainNode;
  label?: string;
  labelStyles?: TextProps["style"];
  labelRight?: string;
  rightChild?: React.ReactNode;
  isDisabled?: boolean;
}

export type SelectGroupProps = React.PropsWithChildren<{
  label: string;
}>;

export const SelectGroup: React.FC<
  React.PropsWithChildren<SelectGroupProps>
> = () => null;
SelectGroup.displayName = "SelectGroup";

export const SelectOption: React.FC<SelectOptionProps> = () => null;
SelectOption.displayName = "SelectOption";
